import { useEffect, useState } from "react";
import { FaImage, FaRegEdit, FaTrash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { updateFormInfo } from "../../redux/slice/formUpdateSlice";

const ColorItem = (props) => {
  const [item] = useState(props.item);
  const dispatch = useDispatch();

  const editItem = () => {
    dispatch(updateFormInfo({ displayForm: true, formData: { item } }));
  };

  return (
    <tr key={item.id}>
      {/* <th scope="row">{od.id}</th> */}
      <td className="align-middle">
        <p>{item.id}</p>
      </td>
      {/* <td className="align-middle"><img src={item.image_path} alt={item.name} width="100px" /></td> */}
      <td className="align-middle">
        <p>{item.name}</p>
      </td>
      <td className="align-middle">
        <p>{item.color_code}</p>
      </td>
      <td className="align-middle">
        <p>{item.status}</p>
      </td>
      <td className="align-middle">
        <p className="col-lg-12 d-flex justify-content-center">
          <span
            className="edit-icon-btn"
            onClick={() => {
              editItem();
            }}
          >
            <FaRegEdit />
          </span>{" "}
          {/* <span className="delete-icon-btn">
            <FaTrash />
          </span> */}
        </p>
      </td>
    </tr>
  );
};

export default ColorItem;
